module.exports = __webpack_public_path__ + "img/tairitsu_summer.67558747.png";